import { useState, useEffect } from "react";

const API_URL = "https://1tv3zhvhb6.execute-api.eu-west-2.amazonaws.com/production/analyse";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Source+Serif+4:wght@500;600;700&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    background: #fcfbf8;
    color: #111111;
    font-family: 'Inter', sans-serif;
    min-height: 100vh;
  }

  .page {
    max-width: 980px;
    margin: 0 auto;
    padding: 40px 24px 96px;
  }

  .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 72px;
  }

  .brand {
    background: none;
    border: none;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #111111;
  }

  .nav-link {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #111111;
    text-decoration: none;
  }

  .hero {
    padding-bottom: 56px;
    border-bottom: 1px solid #e7e7e7;
    margin-bottom: 40px;
  }

  .eyebrow {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6a6a6a;
    margin-bottom: 18px;
  }

  .title {
    font-family: 'Source Serif 4', serif;
    font-size: clamp(42px, 7vw, 72px);
    line-height: 0.98;
    letter-spacing: -0.03em;
    color: #1f3b63;
    max-width: 760px;
    margin-bottom: 20px;
  }

  .subtitle {
    font-size: 18px;
    line-height: 1.75;
    color: #444444;
    max-width: 700px;
  }

  .input-wrap {
    margin-top: 32px;
    max-width: 760px;
  }

  .url-input {
    width: 100%;
    border: 1px solid #dcdcdc;
    border-radius: 14px;
    background: #fcfbf8;
    color: #111111;
    font-family: 'Inter', sans-serif;
    font-size: 15px;
    line-height: 1.5;
    padding: 16px 18px;
    outline: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    margin-bottom: 14px;
  }

  .url-input::placeholder {
    color: #8a8a8a;
  }

  .url-input:focus {
    border-color: #111111;
    box-shadow: 0 0 0 3px rgba(17,17,17,0.04);
  }

  .hero-actions {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
  }

  .primary-btn {
    appearance: none;
    border: none;
    background: #1f3b63;
    color: #ffffff;
    padding: 14px 22px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.2s ease;
  }

  .primary-btn:hover {
    opacity: 0.88;
  }

  .primary-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  .secondary-btn {
    appearance: none;
    border: 1px solid #d7d7d7;
    background: transparent;
    color: #111111;
    padding: 13px 20px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;
  }

  .secondary-btn:hover {
    border-color: #111111;
    background: #fafafa;
  }

  .loading {
    padding: 42px 0 12px;
    max-width: 760px;
  }

  .loading-label {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6a6a6a;
    margin-bottom: 10px;
  }

  .loading-text {
    font-family: 'Source Serif 4', serif;
    font-size: 28px;
    line-height: 1.25;
    color: #111111;
    margin-bottom: 8px;
  }

  .loading-subtext {
    font-size: 15px;
    color: #555555;
    line-height: 1.7;
  }

  .error-box {
    margin-top: 16px;
    max-width: 760px;
    padding: 14px 16px;
    border: 1px solid #ecd6d6;
    background: #fcf7f7;
    border-radius: 12px;
    color: #7a2f2f;
    font-size: 14px;
    line-height: 1.6;
  }

  .history-panel {
    margin-top: 28px;
    max-width: 760px;
    border: 1px solid #e7e7e7;
    border-radius: 16px;
    background: #f9fafc;
    padding: 18px;
  }

  .history-top {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    margin-bottom: 14px;
    flex-wrap: wrap;
  }

  .history-title {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #4b5563;
  }

  .history-clear {
    appearance: none;
    border: none;
    background: transparent;
    color: #6f2f2f;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .history-clear:hover {
    text-decoration: underline;
  }

  .history-list {
    display: grid;
    gap: 12px;
  }

  .history-item {
    border: 1px solid #e6e6e6;
    border-radius: 14px;
    background: #ffffff;
    padding: 14px 16px;
  }

  .history-item-top {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
  }

  .history-item-main {
    min-width: 0;
    flex: 1;
  }

  .history-item-title {
    font-size: 16px;
    font-weight: 600;
    color: #1f3b63;
    line-height: 1.5;
    margin-bottom: 6px;
  }

  .history-item-meta {
    font-size: 13px;
    color: #666666;
    line-height: 1.6;
    margin-bottom: 10px;
  }

  .history-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .history-badge {
    display: inline-flex;
    align-items: center;
    border: 1px solid #e2e2e2;
    border-radius: 999px;
    padding: 6px 10px;
    font-size: 11px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #444444;
    background: #fafafa;
  }

  .history-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .history-btn {
    appearance: none;
    border: 1px solid #d7d7d7;
    background: transparent;
    color: #111111;
    padding: 10px 14px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    cursor: pointer;
  }

  .history-btn:hover {
    border-color: #111111;
    background: #fafafa;
  }

  .history-empty {
    font-size: 14px;
    line-height: 1.7;
    color: #666666;
  }

  .helper-text {
    margin-top: 10px;
    font-size: 13px;
    line-height: 1.6;
    color: #666666;
  }

  .text-input {
    width: 100%;
    min-height: 220px;
    border: 1px solid #dcdcdc;
    border-radius: 14px;
    background: #fcfbf8;
    color: #111111;
    font-family: 'Inter', sans-serif;
    font-size: 15px;
    line-height: 1.6;
    padding: 16px 18px;
    outline: none;
    resize: vertical;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    margin-bottom: 14px;
  }

  .text-input:focus {
    border-color: #111111;
    box-shadow: 0 0 0 3px rgba(17,17,17,0.04);
  }

  .sub-input {
    width: 100%;
    border: 1px solid #dcdcdc;
    border-radius: 14px;
    background: #fcfbf8;
    color: #111111;
    font-family: 'Inter', sans-serif;
    font-size: 15px;
    line-height: 1.5;
    padding: 14px 16px;
    outline: none;
    margin-bottom: 12px;
  }

  .sub-input:focus {
    border-color: #111111;
    box-shadow: 0 0 0 3px rgba(17,17,17,0.04);
  }

  .badge-row {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 18px;
  }

  .meta-badge {
    display: inline-flex;
    align-items: center;
    border: 1px solid #e2e2e2;
    border-radius: 999px;
    padding: 8px 12px;
    font-size: 12px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #444444;
    background: #fafafa;
  }

  .warning-list {
    display: grid;
    gap: 12px;
    margin-top: 14px;
  }

  .warning-card {
    padding: 14px 16px;
    border: 1px solid #ecd6d6;
    border-radius: 12px;
    background: #fcf7f7;
    font-size: 14px;
    line-height: 1.65;
    color: #6f2f2f;
  }

  .evidence-box {
    margin-top: 10px;
    padding: 12px 14px;
    border-left: 3px solid #d8dfea;
    background: #f8fafc;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.65;
    color: #4b5563;
  }

  .credibility-grid {
    display: grid;
    gap: 14px;
  }

  .credibility-card {
    padding: 16px 18px;
    border: 1px solid #ebebeb;
    border-radius: 12px;
    background: #fcfcfc;
  }

  .credibility-top {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .credibility-label {
    font-size: 15px;
    font-weight: 600;
    color: #1f3b63;
  }

  .credibility-status {
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    border: 1px solid #e2e2e2;
    border-radius: 999px;
    padding: 6px 10px;
    color: #444444;
    background: #fafafa;
  }

  .credibility-detail {
    font-size: 15px;
    line-height: 1.7;
    color: #333333;
  }

  .section-subsummary {
    margin-bottom: 16px;
    font-size: 15px;
    line-height: 1.75;
    color: #4b4b4b;
  }

  .results {
    margin-top: 8px;
  }

  .section {
    padding: 38px 0;
    border-top: 1px solid #e7e7e7;
  }

  .section-grid {
    display: grid;
    grid-template-columns: 220px 1fr;
    gap: 32px;
    align-items: start;
  }

  .section-label {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6a6a6a;
    padding-top: 6px;
  }

  .section-title {
    font-family: 'Source Serif 4', serif;
    font-size: 32px;
    line-height: 1.15;
    letter-spacing: -0.02em;
    color: #1f3b63;
    margin-bottom: 12px;
  }

  .section-intro {
    font-size: 15px;
    line-height: 1.75;
    color: #4b4b4b;
    max-width: 760px;
    margin-bottom: 24px;
  }

  .bullet-list {
    display: grid;
    gap: 14px;
  }

  .bullet-item {
    display: grid;
    grid-template-columns: 28px 1fr;
    gap: 14px;
    padding: 16px 0;
    border-top: 1px solid #eeeeee;
  }

  .bullet-item:last-child {
    border-bottom: 1px solid #eeeeee;
  }

  .bullet-num {
    font-family: 'Source Serif 4', serif;
    font-size: 20px;
    line-height: 1;
    color: #1d4ed8;
    padding-top: 2px;
  }

  .bullet-text {
    font-size: 15px;
    line-height: 1.75;
    color: #222222;
  }

  .stack-list {
    display: grid;
    gap: 14px;
  }

  .stack-item {
    padding: 16px 18px;
    border: 1px solid #ebebeb;
    border-radius: 12px;
    background: #fcfcfc;
    font-size: 15px;
    line-height: 1.7;
    color: #333333;
  }

  .muted-card {
    padding: 16px 18px;
    border: 1px solid #ebebeb;
    border-radius: 12px;
    background: #fafafa;
    font-size: 15px;
    line-height: 1.7;
    color: #555555;
  }

  .warn-card {
    padding: 16px 18px;
    border: 1px solid #ecd6d6;
    border-radius: 12px;
    background: #fcf7f7;
    font-size: 15px;
    line-height: 1.7;
    color: #6f2f2f;
  }

  .ok-card {
    padding: 16px 18px;
    border: 1px solid #d9e9dc;
    border-radius: 12px;
    background: #f7fbf7;
    font-size: 15px;
    line-height: 1.7;
    color: #2e5f39;
  }

  .coverage-list {
    display: grid;
    gap: 18px;
  }

  .coverage-card {
    border: 1px solid #e8e8e8;
    border-radius: 16px;
    padding: 22px 22px 20px;
    background: #f6f8fc;
  }

  .coverage-meta {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #7a7a7a;
    margin-bottom: 10px;
  }

  .coverage-headline {
    font-family: 'Source Serif 4', serif;
    font-size: 24px;
    line-height: 1.25;
    letter-spacing: -0.01em;
    color: #111111;
    margin-bottom: 10px;
  }

  .coverage-byline {
    font-size: 13px;
    color: #666666;
    margin-bottom: 12px;
    line-height: 1.6;
  }

  .coverage-preview {
    font-size: 15px;
    line-height: 1.75;
    color: #444444;
    margin-bottom: 14px;
  }

  .coverage-link {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #111111;
    text-decoration: none;
    font-weight: 600;
  }

  .coverage-link:hover {
    text-decoration: underline;
  }

  .meta-label {
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7a7a7a;
  margin-bottom: 18px;
  }

  .diff-list {
    display: grid;
    gap: 14px;
  }

  .diff-item {
    padding: 16px 18px;
    border: 1px solid #ebebeb;
    border-radius: 12px;
    background: #fcfcfc;
  }

  .diff-text {
    font-size: 15px;
    line-height: 1.7;
    color: #333333;
    margin-bottom: 10px;
  }

  .diff-link {
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #111111;
    text-decoration: none;
    font-weight: 600;
  }

  .diff-link:hover {
    text-decoration: underline;
  }

  .footer-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    padding-top: 32px;
    border-top: 1px solid #e7e7e7;
    margin-top: 42px;
  }

  @media (max-width: 820px) {
    .section-grid {
      grid-template-columns: 1fr;
      gap: 18px;
    }

    .nav {
      margin-bottom: 56px;
    }

    .hero {
      padding-bottom: 44px;
    }
  }

  @media (max-width: 560px) {
    .page {
      padding: 28px 18px 72px;
    }

    .title {
      font-size: 42px;
    }

    .subtitle {
      font-size: 16px;
    }

    .section {
      padding: 30px 0;
    }

    .section-title {
      font-size: 28px;
    }

    .coverage-headline {
      font-size: 21px;
    }

    .hero-actions,
    .footer-actions {
      flex-direction: column;
      align-items: stretch;
    }

    .primary-btn,
    .secondary-btn {
      width: 100%;
      text-align: center;
    }
  }
`;

function NumberedList({ items = [] }) {
  return (
    <div className="bullet-list">
      {items.map((item, i) => (
        <div key={i} className="bullet-item">
          <div className="bullet-num">{String(i + 1).padStart(2, "0")}</div>
          <div className="bullet-text">{item}</div>
        </div>
      ))}
    </div>
  );
}

function StackList({ items = [], className = "stack-item" }) {
  return (
    <div className="stack-list">
      {items.map((item, i) => (
        <div key={i} className={className}>{item}</div>
      ))}
    </div>
  );
}

function EvidenceText({ evidence }) {
  if (!evidence) return null;
  return <div className="evidence-box">Evidence: {evidence}</div>;
}

function CredibilityChecks({ data }) {
  if (!data?.checks?.length) {
    return <div className="muted-card">No detailed credibility checks available.</div>;
  }

  return (
    <div className="credibility-grid">
      {data.checks.map((item, i) => (
        <div key={i} className="credibility-card">
          <div className="credibility-top">
            <div className="credibility-label">{item.label}</div>
            <div className="credibility-status">{item.status || "mixed"}</div>
          </div>
          <div className="credibility-detail">{item.detail}</div>
          <EvidenceText evidence={item.evidence} />
        </div>
      ))}
    </div>
  );
}

export default function NewsAnalyser() {
  const [url, setUrl] = useState("");
  const [articleTitle, setArticleTitle] = useState("");
  const [articleText, setArticleText] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingStep, setLoadingStep] = useState("");
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [history, setHistory] = useState([]);

  const totalSources = results?.meta?.totalSources || 1;

  const HISTORY_KEY = "newsdepth_history";
  const HISTORY_LIMIT = 20;

  const loadHistory = () => {
    try {
      const raw = localStorage.getItem(HISTORY_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const saveHistory = (items) => {
    try {
      localStorage.setItem(HISTORY_KEY, JSON.stringify(items));
    } catch (err) {
      console.error("Could not save history:", err);
    }
  };

  const addToHistory = (result) => {
    if (!result) return;

    const entry = {
      id: result.shareId || `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      savedAt: new Date().toISOString(),
      title:
        result?.mainArticle?.title ||
        result?.otherCoverage?.[0]?.headline ||
        "Untitled analysis",
      outlet: result?.mainArticle?.outlet || "",
      url: result?.mainArticle?.url || "",
      shareId: result?.shareId || "",
      confidence: result?.meta?.confidence?.label || "",
      totalSources: result?.meta?.totalSources || 1,
      result,
    };

    const existing = loadHistory();

    const deduped = existing.filter((item) => {
      if (entry.shareId && item.shareId) {
        return item.shareId !== entry.shareId;
      }
      if (entry.url && item.url) {
        return item.url !== entry.url;
      }
      return item.id !== entry.id;
    });

    const updated = [entry, ...deduped].slice(0, HISTORY_LIMIT);
    setHistory(updated);
    saveHistory(updated);
  };

  const openHistoryItem = (item) => {
    if (!item?.result) return;
    setResults(item.result);
    setError(null);
    setCopied(false);
    setUrl("");
    setArticleTitle("");
    setArticleText("");

    if (item.shareId) {
      window.history.replaceState({}, "", `?share=${item.shareId}`);
    } else {
      window.history.replaceState({}, "", window.location.pathname);
    }
  };

  const deleteHistoryItem = (id) => {
    const updated = history.filter((item) => item.id !== id);
    setHistory(updated);
    saveHistory(updated);
  };

  const clearHistory = () => {
    setHistory([]);
    localStorage.removeItem(HISTORY_KEY);
  };

  const formatHistoryDate = (isoString) => {
    try {
      return new Date(isoString).toLocaleString("en-GB", {
        dateStyle: "medium",
        timeStyle: "short",
      });
    } catch {
      return "";
    }
  };

  const getSourceLabel = (count) => {
    if (count <= 1) return "Based on 1 source (limited coverage)";
    if (count === 2) return "Based on 2 sources";
    return `Based on ${count} sources`;
  };
  
  const getConfidenceSummary = () => {
  const confidenceLabel = results?.meta?.confidence?.label || "";
  const confidenceReason = results?.meta?.confidence?.reason || "";
  const warnings = results?.meta?.extraction?.warnings || [];

  if (!confidenceLabel && warnings.length === 0) return "";

  const warningText = warnings[0] || "";

  if (confidenceReason && warningText) {
    return `${confidenceReason} ${warningText}`;
  }

  return confidenceReason || warningText;
  };

  useEffect(() => {
    setHistory(loadHistory());

    const params = new URLSearchParams(window.location.search);
    const shareId = params.get("share");

    if (shareId) {
      setLoading(true);
      setLoadingStep("Loading saved analysis");

      fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shareId }),
      })
        .then((res) => res.json())
        .then((data) => {
          setResults(data);
          addToHistory(data);
          setLoading(false);
        })
        .catch(() => {
          setError("Could not load shared analysis.");
          setLoading(false);
        });
    }
  }, []);

const analyse = async () => {
  if (!url.trim() && !articleText.trim()) {
    setError("Please enter a URL or paste article text.");
    return;
  }

  if (url.trim()) {
    try {
      const parsed = new URL(url.trim());
      if (!["http:", "https:"].includes(parsed.protocol)) {
        setError("Please enter a valid URL starting with http:// or https://");
        return;
      }
    } catch {
      setError("Please enter a valid news article URL.");
      return;
    }
  }

  if (articleText.trim() && articleText.trim().length < 200) {
    setError("Please paste a bit more article text so the analysis has enough to work with.");
    return;
  }

  setLoading(true);
  setLoadingStep("Analysing article");
  setError(null);
  setResults(null);
  setCopied(false);
  
  const post = async (payload) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });

      const rawText = await response.text();
      let data;

      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(
          `Invalid server response (${response.status}).`
        );
      }

      if (!response.ok) {
        const error = new Error(
          data.error ||
          data.message ||
          `Server error: ${response.status}`
        );
        error.status = response.status;
        throw error;
      }

      return data;
    } finally {
      clearTimeout(timer);
    }
  };

  try {
    setLoadingStep("Starting analysis");

    const input = {
      url: url.trim(),
      articleTitle: articleTitle?.trim?.() || "",
      articleText: articleText?.trim?.() || "",
    };

    // Save only a fingerprint and job IDs, not article text.
    const digest = await crypto.subtle.digest(
      "SHA-256",
      new TextEncoder().encode(JSON.stringify(input))
    );

    const fingerprint = Array.from(new Uint8Array(digest))
      .map((value) => value.toString(16).padStart(2, "0"))
      .join("");

    const storageKey = "newsdepthPendingJob";
    let previous = null;

    try {
      previous = JSON.parse(
        sessionStorage.getItem(storageKey) || "null"
      );
    } catch {}

    const now = Date.now();

    let saved =
      previous?.fingerprint === fingerprint &&
      now - previous.startedAt < 360000
        ? previous
        : {
            fingerprint,
            requestId: crypto.randomUUID(),
            startedAt: now,
          };

    sessionStorage.setItem(storageKey, JSON.stringify(saved));

    let jobId = saved.jobId;

    if (!jobId) {
      const accepted = await post({
        ...input,
        requestId: saved.requestId,
      });

      jobId = accepted.jobId;

      if (!jobId) {
        throw new Error(
          "The backend has not been updated for background analysis."
        );
      }

      saved = { ...saved, jobId };
      sessionStorage.setItem(storageKey, JSON.stringify(saved));
    }

    setLoadingStep("Analysing article and comparing coverage");

    const deadline = saved.startedAt + 360000;
    let connectionFailures = 0;

    while (Date.now() < deadline) {
      await new Promise((resolve) => setTimeout(resolve, 2500));

      let job;

      try {
        job = await post({ jobId });
        connectionFailures = 0;
      } catch (err) {
        if (err.status >= 400 && err.status < 500) {
          sessionStorage.removeItem(storageKey);
          throw err;
        }

        connectionFailures += 1;

        if (connectionFailures >= 3) {
          throw new Error(
            "Connection interrupted. Click Analyse again to check the same job."
          );
        }

        continue;
      }

      if (job.status === "completed") {
        sessionStorage.removeItem(storageKey);
        setResults(job.result);
        addToHistory(job.result);
        return;
      }

      if (job.status === "failed") {
        sessionStorage.removeItem(storageKey);
        throw new Error(job.error || "Analysis failed.");
      }

      if (!["pending", "running"].includes(job.status)) {
        throw new Error("Unexpected analysis status.");
      }
    }

    sessionStorage.removeItem(storageKey);

    throw new Error(
      "The analysis exceeded its time limit. Please try again later."
    );
  } catch (err) {
    console.error("Analysis failed:", err);

    setError(
      err.name === "AbortError"
        ? "Connection timed out. Click Analyse again to check the same request."
        : err.message || "Could not complete the analysis."
    );
  } finally {
    setLoading(false);
    setLoadingStep("");
  }
};

  const reset = () => {
    setResults(null);
    setError(null);
    setCopied(false);
    setUrl("");
    setArticleTitle("");
    setArticleText("");
    window.history.replaceState({}, "", window.location.pathname);
  };

  const shareAnalysis = async () => {
    if (!results?.shareId) {
      setError("This analysis cannot be shared right now.");
      return;
    }

    try {
      const shareUrl = `${window.location.origin}?share=${results.shareId}`;
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch {
      setError("Could not copy the share link.");
    }
  };

  return (
    <>
      <style>{styles}</style>

      <div className="page">
        <div className="nav">
          <button className="brand" onClick={reset}>
            NewsDepth
          </button>
          <a href="/how-it-works" className="nav-link">
            How it works
          </a>
        </div>

        <section className="hero">
          <div className="eyebrow">Story understanding</div>
          <h1 className="title">Understand the story behind a single article.</h1>
          <p className="subtitle">
            Paste a news URL to see what happened, how other outlets covered the same
            story, what context may be missing, and what still remains unclear.
          </p>

          {!results && !loading && (
            <div className="input-wrap">
              <input
                className="url-input"
                placeholder="Paste a news article URL"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && analyse()}
              />

              <div className="helper-text">
                If a site blocks scraping, you can paste the article text below instead.
              </div>

              <input
                className="sub-input"
                placeholder="Optional article title"
                value={articleTitle}
                onChange={(e) => setArticleTitle(e.target.value)}
              />

              <textarea
                className="text-input"
                placeholder="Optional fallback: paste the full article text here"
                value={articleText}
                onChange={(e) => setArticleText(e.target.value)}
              />

              <div className="hero-actions">
                <button
                  className="primary-btn"
                  onClick={analyse}
                  disabled={loading || (!url.trim() && !articleText.trim())}
                >
                  {loading ? "Analysing..." : "Analyse article"}
                </button>
              </div>

              {error && <div className="error-box">{error}</div>}
            </div>
          )}

          {!results && !loading && history.length > 0 && (
            <div className="history-panel">
              <div className="history-top">
                <div className="history-title">Recent analyses</div>
                <button className="history-clear" onClick={clearHistory}>
                  Clear all
                </button>
              </div>

              <div className="history-list">
                {history.map((item) => (
                  <div key={item.id} className="history-item">
                    <div className="history-item-top">
                      <div className="history-item-main">
                        <div className="history-item-title">{item.title}</div>

                        <div className="history-item-meta">
                          {item.outlet ? `${item.outlet} · ` : ""}
                          {formatHistoryDate(item.savedAt)}
                        </div>

                        <div className="history-badges">
                          {item.confidence && (
                            <div className="history-badge">{item.confidence}</div>
                          )}
                          <div className="history-badge">
                            {item.totalSources || 1} source{(item.totalSources || 1) > 1 ? "s" : ""}
                          </div>
                        </div>
                      </div>

                      <div className="history-actions">
                        <button
                          className="history-btn"
                          onClick={() => openHistoryItem(item)}
                        >
                          Open
                        </button>

                        <button
                          className="history-btn"
                          onClick={() => deleteHistoryItem(item.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {loading && (
            <div className="loading" aria-live="polite" aria-busy="true">
              <div className="loading-label">Analysis in progress</div>
              <div className="loading-text">{loadingStep || "Analysing article"}</div>
              <div className="loading-subtext">
                NewsDepth is extracting the article, comparing available coverage, and generating a structured summary. This can take longer for blocked, paywalled, or difficult pages.
              </div>
              {error && <div className="error-box">{error}</div>}
            </div>
          )}
        </section>

        {results && (
          <div className="results">
            <section className="section">
              <div className="section-grid">
                <div className="section-label">Summary</div>
                <div>
                  <h2 className="section-title">What likely happened</h2>
                  <p className="section-intro">
                    A neutral reconstruction of the event based on multiple sources.
                  </p>
                  <div className="badge-row">
                    <div className="meta-badge">{getSourceLabel(totalSources)}</div>

                    {results?.meta?.confidence?.label && (
                      <div className="meta-badge">{results.meta.confidence.label}</div>
                    )}
                  </div>

                  {getConfidenceSummary() && (
                    <div className="section-subsummary">
                      <strong>{results?.meta?.confidence?.label || "Confidence"}:</strong>{" "}
                      {getConfidenceSummary()}
                    </div>
                  )}
                  
                  {results.whatHappened?.length > 0 ? (
                    <NumberedList items={results.whatHappened} />
                  ) : (
                    <div className="muted-card">No event summary available.</div>
                  )}
                </div>
              </div>
            </section>

            <section className="section">
              <div className="section-grid">
                <div className="section-label">Article</div>
                <div>
                  <h2 className="section-title">What this article says</h2>
                  <p className="section-intro">
                    The main claims and takeaways presented in the article you pasted.
                  </p>
                  {results.mainClaims?.length > 0 ? (
                    <StackList items={results.mainClaims} />
                  ) : (
                    <div className="muted-card">No main claims identified.</div>
                  )}
                </div>
              </div>
            </section>

            <section className="section">
              <div className="section-grid">
                <div className="section-label">Context</div>
                <div>
                  <h2 className="section-title">What you might be missing</h2>
                  <p className="section-intro">
                    Background, detail, or perspective that may help you understand the story more fully.
                  </p>
                  {results.missingContext?.length > 0 ? (
                    <div className="diff-list">
                      {results.missingContext.map((item, i) => (
                        <div key={i} className="diff-item">
                          <div className="diff-text">
                            {typeof item === "string" ? item : item.text}
                          </div>

                          {typeof item !== "string" && item.url && (
                            <a
                              className="diff-link"
                              href={item.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {item.outlet ? `Read ${item.outlet}` : "Read source"}
                            </a>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="muted-card">No major context gaps identified.</div>
                  )}
                </div>
              </div>
            </section>

            <section className="section">
              <div className="section-grid">
                <div className="section-label">Comparison</div>
                <div>
                  <h2 className="section-title">Where coverage differs</h2>
                  <p className="section-intro">
                    Meaningful differences in emphasis, detail, chronology, or factual framing
                    across other reporting on the same story.
                  </p>
                  {results.coverageDifferences?.length > 0 ? (
                    <div className="diff-list">
                      {results.coverageDifferences.map((item, i) => (
                        <div key={i} className="diff-item">
                          <div className="diff-text">
                            {typeof item === "string" ? item : item.text}
                          </div>

                          {typeof item !== "string" && item.evidence && (
                            <EvidenceText evidence={item.evidence} />
                          )}

                          {typeof item !== "string" && item.url && (
                            <a
                              className="diff-link"
                              href={item.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {item.outlet ? `Read ${item.outlet}` : "Read source"}
                            </a>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="muted-card">No major coverage differences identified.</div>
                  )}
                </div>
              </div>
            </section>

            <section className="section">
              <div className="section-grid">
                <div className="section-label">Uncertainty</div>
                <div>
                  <h2 className="section-title">What’s still unclear</h2>
                  <p className="section-intro">
                    Open questions, unresolved points, or aspects of the story that remain uncertain.
                  </p>
                  {results.whatIsUnclear?.length > 0 ? (
                    <StackList items={results.whatIsUnclear} />
                  ) : (
                    <div className="muted-card">No major unresolved points identified.</div>
                  )}
                </div>
              </div>
            </section>

            <section className="section">
              <div className="section-grid">
                <div className="section-label">Other coverage</div>
                <div>
                  <h2 className="section-title">How others covered it</h2>
                  <p className="section-intro">
                    Related reporting so you can compare how the same story appears across outlets.
                  </p>

                  {results.otherCoverage?.length > 0 ? (
                    <div className="coverage-list">
                      {results.otherCoverage.map((item, i) => (
                        <div key={i} className="coverage-card">
                          <div className="coverage-meta">{item.outlet}</div>
                          <div className="coverage-headline">{item.headline}</div>

                          {(item.author || item.publishedAt) && (
                            <div className="coverage-byline">
                              {item.author && <span>By {item.author}</span>}
                              {item.author && item.publishedAt && <span> · </span>}
                              {item.publishedAt && <span>{item.publishedAt}</span>}
                            </div>
                          )}

                          <div className="coverage-preview">
                            {item.preview || "Related coverage of the same story."}
                          </div>

                          {item.url && (
                            <a
                              className="coverage-link"
                              href={item.url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Read article
                            </a>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="muted-card">No related coverage available.</div>
                  )}
                </div>
              </div>
            </section>

            <section className="section">
              <div className="section-grid">
                <div className="section-label">Credibility</div>
                <div>
                  <h2 className="section-title">Source credibility</h2>
                  <p className="section-intro">
                    Visible credibility issues found in the article, such as anonymous sourcing
                    or unsupported claims.
                  </p>
                  {results.sourceCredibility?.summary && (
                    <div className="section-subsummary">
                      {results.sourceCredibility.summary}
                    </div>
                  )}

                  {results.sourceCredibility?.issues?.length > 0 && (
                    <div style={{ marginBottom: "16px" }}>
                      <StackList
                        items={results.sourceCredibility.issues.map((x) => `⚠ ${x}`)}
                        className="warn-card"
                      />
                    </div>
                  )}
                  <CredibilityChecks data={results.sourceCredibility} />
                </div>
              </div>
            </section>

            <section className="section">
              <div className="section-grid">
                <div className="section-label">Questions</div>
                <div>
                  <h2 className="section-title">Questions to consider</h2>
                  <p className="section-intro">
                    Useful follow-up questions that may help you read the story more critically.
                  </p>
                  {results.questionsToConsider?.length > 0 ? (
                    <StackList items={results.questionsToConsider} />
                  ) : (
                    <div className="muted-card">No follow-up questions identified.</div>
                  )}
                </div>
              </div>
            </section>

            <div className="footer-actions">
              <button className="secondary-btn" onClick={reset}>
                New analysis
              </button>
              <button className="primary-btn" onClick={shareAnalysis}>
                {copied ? "Link copied" : "Share analysis"}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}